import React, { ReactNode } from 'react';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';

function ScheduleCustomErrorState({
  onTryAgain,
  title,
}: {
  onTryAgain: () => void;
  title?: string | ReactNode;
}) {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.CRANE_CONSTRUCTION_GREY}
      description={title || T.translate('EMPTY_STATE.ERROR_ACTIVITIES_TITLE')}
    >
      <LinkButton onClick={onTryAgain}>
        {T.translate('EMPTY_STATE.RETRY')}
      </LinkButton>
    </EmptyState>
  );
}

export default ScheduleCustomErrorState;
